import { isArrayEmpty, getItemById } from '../../../utility/helpers';
import {
  CREATE_SURVEY_FIELD_NAMES,
  SURVEY_TYPES,
} from '../../../constants/survey';
import { ATTRIBUTES } from '../../../constants/attributes';
import { ATTRIBUTE_TYPES_MAP } from '../../pages/attributesPage/config';
import { getQuestionText } from '../../../utility/uiUtils';
import {
  CUSTOM_QUESTIONNAIRE_ATTRIBUTE_ID,
  normalizeQuestionnaireQuestionPreview,
  getQuestionnaireQuestions,
} from '../../../utility/survey';

const {
  CREATED_FOR,
  SURVEY_TYPE,
  HAS_QUESTIONNAIRE,
  QUESTIONNAIRE,
  ATTRIBUTES: ATTRIBUTES_FIELD,
} = CREATE_SURVEY_FIELD_NAMES;

export const isPreviewAvailable = (values, customQuestions) => {
  const isCompanyPulse = values[SURVEY_TYPE] === SURVEY_TYPES.PULSE;
  const isEnps = [SURVEY_TYPES.NPS, SURVEY_TYPES.ENPS].includes(
    values[SURVEY_TYPE]
  );
  const questions = customQuestions
    ? getQuestionnaireQuestions(customQuestions)
    : getQuestionnaireQuestions(values[QUESTIONNAIRE]);

  if (isEnps) return true;

  if (values[HAS_QUESTIONNAIRE]) {
    if (isCompanyPulse) {
      return !isArrayEmpty(questions);
    }

    return !isArrayEmpty(questions) && !isArrayEmpty(values[CREATED_FOR]);
  }

  if (isCompanyPulse) return !isArrayEmpty(values[ATTRIBUTES_FIELD]);

  return (
    !isArrayEmpty(values[ATTRIBUTES_FIELD]) &&
    !isArrayEmpty(values[CREATED_FOR])
  );
};

export const getOrganizationSubject = organizationName => [
  { id: 1, first_name: organizationName, last_name: '' },
];

export const prepareAttributeData = (attribute, createdFor, values) => {
  const isSelfAssessment = values[SURVEY_TYPE] === SURVEY_TYPES.SELF;
  const isCompanyPulse = values[SURVEY_TYPE] === SURVEY_TYPES.PULSE;
  const isEnps = attribute.type === ATTRIBUTE_TYPES_MAP.ENPS.id;

  const subjects =
    isSelfAssessment || isCompanyPulse
      ? [
          {
            ...createdFor[0],
            ...(isCompanyPulse ? { first_name: values.company } : {}),
          },
        ]
      : createdFor;

  const subjectsWithTracking = subjects.map((subject, index) => ({
    ...subject,
    review_tracking: subject.review_tracking ?? subject.id ?? index + 1,
  }));

  const { questions: attributeQuestions } = attribute;

  if (isArrayEmpty(attributeQuestions)) return {};

  let questions = attributeQuestions;

  if (isEnps) {
    questions = attributeQuestions.map(question => ({
      ...question,
      text: getQuestionText(question.text, values.company),
    }));
  } else if (attribute.id === CUSTOM_QUESTIONNAIRE_ATTRIBUTE_ID) {
    questions = attributeQuestions.map(normalizeQuestionnaireQuestionPreview);
  }

  return {
    ...attribute,
    questions,
    isEnps,
    hasAnswerComment: getItemById(values?.attributes, attribute.id)
      ?.has_answer_comment,
    subjects: subjectsWithTracking,
    results: {},
    comments: [],
    isVertical: attribute.layout === ATTRIBUTES.verticalLayout,
    hasNeutralAnswer: attribute[ATTRIBUTES.fields.withNeutralAnswer],
    hasAdditionalFeedback: attribute[ATTRIBUTES.fields.withAdditionalFeedback],
    withTextReplyQuestions:
      attribute?.[ATTRIBUTES.fields.withTextReplyQuestions],
    totalSteps: attributeQuestions.length + 1,
  };
};
